document.addEventListener("DOMContentLoaded", () => {

const header = document.querySelector(".header");
  const toggler = document.querySelector(".header__toggler");
  const nav = document.querySelector(".header__navigation");
  const body = document.querySelector("body");

  const isMobile = () => window.matchMedia("(max-width: 980px)").matches;

  // --- shrink on scroll (class-based) ---
  const onScroll = () => {
    header.classList.toggle("header--scrolled", window.scrollY > 8);
  };
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  // --- open/close helpers ---
  const closeMenu = () => {
    nav.classList.remove("header__navigation--open");
    toggler.classList.remove("header__toggler--open");
    nav.querySelectorAll(".menu__item--open").forEach((li) => li.classList.remove("menu__item--open"));
  };

  // --- mobile main toggle ---
  toggler.addEventListener("click", () => {
    nav.classList.toggle("header__navigation--open");
    toggler.classList.toggle("header__toggler--open");
    document.body.classList.toggle('no-scroll');

  });

  // --- close on ESC ---
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeMenu();
  });

  // --- mobile submenu toggles ---
  nav.querySelectorAll(".menu__item--has-children > .menu__link").forEach((link) => {
    link.addEventListener("click", (e) => {
      if (!isMobile()) return; // desktop stays hover/focus
      e.preventDefault();

      const li = link.closest(".menu__item--has-children");
      if (!li) return;

      li.classList.toggle("menu__item--open");
    });
  });

  // --- reset on resize to desktop ---
  window.addEventListener(
    "resize",
    () => {
      if (!isMobile()) closeMenu();
    },
    { passive: true }
  );

  
  });